<template>
  <section class="register-page app-content d-flex">
    <div class="container">

      <div class="row justify-content-between mt-4">
        <div class="col text-left">
          <router-link :to="{ name: 'login' }" class="btn-zuruck">
            <img src="~assets/img/go_back.png"/>Zurück
          </router-link>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="form-container">
          <form @submit.prevent="submit" id="registration-form" class="auth-form">
            <div class="form-group">
              <b-form-input v-model="user.firstname" :state="(!user.firstname && statuscode === 70) ? false : null" placeholder="VORNAME"></b-form-input>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group">
              <b-form-input v-model="user.lastname" :state="(!user.lastname && statuscode === 70) ? false : null" placeholder="NACHNAME"></b-form-input>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group mt-5">
              <img v-show="emailCorrect" class="input-correct" :src="'./static/img/eltern/check_filled.png'">
              <b-form-input v-model="user.mail" :state="(statuscode === 70 || statuscode === 82 || (!emailCorrect && user.mail)) ? false : null" placeholder="E-MAIL"></b-form-input>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group">
              <img v-show="emailCorrect && user.mail === user.mailConfirmation" class="input-correct" :src="'./static/img/eltern/check_filled.png'">
              <b-form-input v-model="user.mailConfirmation" :state="(statuscode === 11) ? false : null" placeholder="E-MAIL WIEDERHOLEN"></b-form-input>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group">
              <img v-show="passwordCorrect" class="input-correct" :src="'./static/img/eltern/check_filled.png'">
              <b-form-input id="password-input" v-model="user.password" :state="(!user.password && statuscode === 70 || statuscode === 14) ? false : null" type="password" placeholder="PASSWORT"></b-form-input>
              <b-tooltip target="password-input" placement="right">
                Passwort muss mindestens 8 Zeichen, 1 Großbuchstaben und 1 Zahl enthalten
              </b-tooltip>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group">
              <img v-show="passwordCorrect && user.password === user.passwordConfirmation" class="input-correct" :src="'./static/img/eltern/check_filled.png'">
              <b-form-input v-model="user.passwordConfirmation" :state="(statuscode === 12) ? false : null" type="password" placeholder="PASSWORT WIEDERHOLEN"></b-form-input>
              <b-form-invalid-feedback>
                {{ alert.error }}
              </b-form-invalid-feedback>
            </div>
            <div class="form-group mt-5">
              <label class="auth-input-label mb-0">ELTERNCODE</label>
              <b-form-input v-model="user.code" :state="(!user.code && statuscode === 70 || statuscode === 81 || statuscode === 80) ? false : null" class="mt-0 non-animated" placeholder="0 0 0 0 0 0 0 0"/></b-form-input>
              <b-form-invalid-feedback>
                <div v-if="statuscode === 70">Bitte geben Sie einen Elterncode an.</div>
                <div v-else>{{ alert.error }}</div>
              </b-form-invalid-feedback>
            </div>
            <div class="form-group">
              <label class="checkbox-custom">
                <p>Ich bin mit den <a class="inline-link" href="https://www.klassenpinnwand.at/support/nutzungsbestimmungen" target="_blank">Nutzungsbestimmungen</a>
                  einverstanden.
                </p>
                <input type="checkbox" ref="AGBcheckbox">
                <span class="checkmark"><img src="~assets/img/ok.png" alt=""></span>
              </label>
            </div>
            <div class="form-group">
              <label class="checkbox-custom no-checkbox">
                <p class="data-info">
                  Ihre Daten werden zur Nutzung und Durchführung der Klassenpinnwand und hallo App von der Direktion der jeweiligen Schule als Verantwortlicher gemäß  <a class="inline-link" href="https://klassenpinnwand.at/support/datenschutz" target="_blank">Datenschutzerklärung</a> verarbeitet.</p>
              </label>
              <div v-show="statuscode === 13" class="invalid-without-submit mt-4">{{ alert.error }}</div>
            </div>
          </form>
          <button @click="submit()" :disabled="processing" class="btn-submit mb-4">
            <span v-show="!processing">Weiter</span>
            <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
          </button>
        </div>
      </div>

    </div>
  </section>

</template>

<script>
import account from '@/api/v1/account';
import Alert from '@/components/Helpers/Alert';
import FormError from '@/components/Helpers/FormError';
// Mixins
import alert from '@/mixins/alert';

function emailCorrect(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test((email || '').toLowerCase());
};

export default {
  components: { Alert, FormError },
  mixins: [alert],
  data() {
    return {
      user: {
        teacher: false,
        firstname: '',
        lastname: '',
        mail: '',
        password: '',
        code: '',
      },
      processing: false,
      statuscode: 0,
    };
  },
  computed: {
    emailCorrect() {
      return emailCorrect(this.user.mail);
    },
    passwordCorrect() {
      const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      return re.test(String(this.user.password));
    },
  },
  methods: {
    validateEmail() {
      this.alert.error = '';
      if (!emailCorrect(this.user.mail)) this.alert.error = 'Bitte geben Sie eine gültige E-Mail Adresse an.';
    },
    submit() {
      this.clearAlerts();
      this.validateEmail();

      const user = this.user;
      if (user.mail !== user.mailConfirmation) {
        this.alert.error = 'E-Mail Adressen stimmen nicht überein';
        this.statuscode = 11;
      }
      if (user.password !== user.passwordConfirmation) {
        this.alert.error = 'Passwörter stimmen nicht überein';
        this.statuscode = 12;
      }
      if (!this.passwordCorrect) {
        this.alert.error = 'Passwort muss mindestens 8 Zeichen, 1 Großbuchstaben und 1 Zahl enthalten';
        this.statuscode = 14;
      }
      if (!this.$refs.AGBcheckbox.checked) {
        this.alert.error = 'Bitte akzeptieren Sie die AGB';
        this.statuscode = 13;
      }
      // if (!this.$refs.privacyCheckbox.checked) {
      //   this.alert.error = 'Bitte akzeptieren Sie die Datenschutzerklärung';
      //   this.statuscode = 13;
      // }

      const succ = () => {
        this.alert.success = 'Success!';
        this.$router.push({ name: 'email_confirmation' });
      };
      const err = (response) => {
        const message = ((statuscode) => {
          switch (statuscode) {
            case 11:
              return 'Es exisitert bereits ein User mit dieser E-Mail Adresse';
            case 70:
              return 'Bitte alle Felder ausfüllen';
            case 80:
              return 'Dieser Elterncode konnte nicht gefunden werden';
            case 81:
              return 'Mit diesem Elterncode wurde bereits ein User angelegt';
            case 82:
              return 'Es exisitert bereits ein User mit dieser E-Mail Adresse';
            default:
              return 'Eingabe ungültig';
          }
        })(response.statuscode);

        this.alert.error = message;
        if (message) this.statuscode = response.statuscode;
        this.processing = false;
      };

      if (!this.alert.error && this.emailCorrect) {
        this.processing = true;
        account.signup(this.user, succ, err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Auth/Registration.vue